// extracted by mini-css-extract-plugin
export var img = "Image-module--img--b87cd";